import React from 'react';

/**
 * ローディングスピナーコンポーネント
 */
const LoadingSpinner = ({ size = 'medium', className = '' }) => {
  const sizeClass = size === 'small' ? 'small' : size === 'large' ? 'large' : '';
  
  return (
    <div className={`spinner ${sizeClass} ${className}`}></div>
  );
};

export default LoadingSpinner;



